import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

const LevelIcon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    backColor?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={props.width ?? 37} height={props.height ?? 37} viewBox="0 0 37 37" fill="none">
          <Rect
            x="1.19922"
            y="0.800781"
            width="35"
            height="35"
            rx="7.5"
            fill={props.backColor ?? '#FFF5DD'}
          />
          <Rect x="1.19922" y="0.800781" width="35" height="35" rx="7.5" stroke="#FCEABB" />
          <G clipPath="url(#clip0_3741_32695)">
            <Path
              d="M30.6992 18.3008C30.6992 21.6134 29.3558 24.6139 27.1841 26.7856C25.0123 28.9573 22.0119 30.3008 18.6992 30.3008C15.3861 30.3008 12.3856 28.9573 10.2144 26.7856C8.04266 24.6139 6.69922 21.6134 6.69922 18.3008C6.69922 14.9877 8.04266 11.9872 10.2144 9.81594C12.3856 7.64422 15.3861 6.30078 18.6992 6.30078C22.0119 6.30078 25.0123 7.64422 27.1841 9.81594C29.3558 11.9872 30.6992 14.9877 30.6992 18.3008ZM21.1231 19.295V22.4375C21.1231 22.7909 20.833 23.0806 20.4795 23.0806H16.9189C16.5659 23.0806 16.2758 22.7914 16.2758 22.4375V19.2955H14.2677C13.4942 19.2955 13.1061 18.3753 13.618 17.817L18.0589 12.6341C18.4077 12.2122 19.0447 12.2122 19.4023 12.6172L23.795 17.8348C24.2961 18.4095 23.8719 19.2945 23.1298 19.295H21.1231ZM26.0694 25.6709C27.9547 23.7847 29.1214 21.1784 29.1214 18.3008C29.1214 15.4227 27.9547 12.8164 26.0694 10.9306C24.1831 9.04484 21.5769 7.87859 18.6992 7.87859C15.8211 7.87859 13.2148 9.04484 11.3291 10.9306C9.44328 12.8164 8.27703 15.4227 8.27703 18.3008C8.27703 21.1784 9.44328 23.7847 11.3291 25.6709C13.2148 27.5563 15.8211 28.723 18.6992 28.723C21.5769 28.723 24.1831 27.5563 26.0694 25.6709Z"
              fill={props.color ?? '#E2753A'}
            />
          </G>
          <Defs>
            <ClipPath id="clip0_3741_32695">
              <Rect width="24" height="24" fill="white" transform="translate(6.69922 6.30078)" />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { LevelIcon };
